import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {
    type UserTemplateAdditionalColumn,
    userTemplateAdditionalColumnsZodValidator,
} from "@vesta/vos-types/modules/workspaceLevel/users/domain/UserTemplateAdditionalColumns";
import {
    type UserTemplateConfiguration,
    userTemplateConfigurationValidator,
} from "@vesta/vos-types/modules/workspaceLevel/users/domain/UserTemplateConfiguration";

export type UserTemplate = {
    additionalColumns: Array<UserTemplateAdditionalColumn>;
    configuration: UserTemplateConfiguration;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    description: string | null;
    displayName: string;
    id: Uuid;
    instanceDisplayNameTemplate: string;
    parentId: Uuid | null;
    status: UserTemplateStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export enum UserTemplateStatus {
    active = "c5b8648e-38aa-4a40-a3fc-16bf255b9cf2",
    archived = "d1cf3790-c095-4f9b-86b1-ada758f21a2a",
};

export const userTemplateValidator: zod.ZodType<UserTemplate> = zod.object({
    additionalColumns: userTemplateAdditionalColumnsZodValidator.array(),
    configuration: userTemplateConfigurationValidator,
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    description: zod.string().nullable(),
    displayName: zod.string(),
    id: uuidZodValidator,
    instanceDisplayNameTemplate: zod.string(),
    parentId: uuidZodValidator.nullable(),
    status: zod.enum(UserTemplateStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
